import { NgClass, NgStyle } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CmsItem } from '@coin/shared/cms/util';

@Component({
  selector: 'coin-equity-cms-chapter-overview',
  templateUrl: './equity-cms-chapter-overview.component.html',
  styleUrls: ['./equity-cms-chapter-overview.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgStyle]
})
export class EquityCmsChapterOverviewComponent implements OnInit, OnChanges {
  @Input() item: CmsItem[];
  @Input() contentEdit = false;
  @Input() update = true;
  @Input() collapsed = false;

  public usedChapters: CmsItem[] = [];

  /**
   * On any changes look for new chapters and filter for these
   * @param changes SimpleChanges Object trigger item
   */
  ngOnChanges(): void {
    if (this.item) {
      this.usedChapters = this.item.filter(itm => itm.type === 'chapter');
    }
  }

  ngOnInit(): void {
    this.usedChapters = this.item?.filter(itm => itm.type === 'chapter');
  }

  /**
   * On any chapter click, scroll to the respective item in view
   * @param chapter Object that has been clicked
   */
  public chapterClick(chapter: CmsItem): void {
    if (chapter.id) {
      const chapterElement = document.getElementById(chapter.id);
      if (chapterElement) {
        chapterElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
